"use client";

import { useEffect, useRef, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
type Stat = {
  value: number;
  suffix: string;
  label: string;
  description: string;
};
const stats: Stat[] = [{
  value: 10,
  suffix: "+",
  label: "YEARS OF EXPERIENCE",
  description: "Más de una década entregando excelencia estructural en toda la región de Vancouver."
}, {
  value: 50,
  suffix: "+",
  label: "COMPLETED PROJECTS",
  description: "Desde cimientos residenciales hasta complejos comerciales de gran escala."
}, {
  value: 100,
  suffix: "%",
  label: "SITE\xA0 SAFETY",
  description: "Comprometidos con los estándares más estrictos de seguridad y calidad en cada obra."
}];
function CountUp({
  end,
  suffix,
  isVisible
}: {
  end: number;
  suffix: string;
  isVisible: boolean;
}) {
  const [count, setCount] = useState(0);
  const hasAnimated = useRef(false);
  useEffect(() => {
    if (!isVisible || hasAnimated.current) return;
    hasAnimated.current = true;
    const duration = 2000;
    const startTime = performance.now();
    const isDecimal = end % 1 !== 0;
    const animate = (now: number) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = end * eased;
      setCount(isDecimal ? Number(current.toFixed(1)) : Math.floor(current));
      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        setCount(end);
      }
    };
    requestAnimationFrame(animate);
  }, [end, isVisible]);
  const displayValue = end % 1 !== 0 ? count.toFixed(1) : count.toString();
  return <span>
      {displayValue}
      {suffix}
    </span>;
}
export default function Impacto() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="2575" id="impacto-en-cifras" className="bg-background text-foreground relative overflow-hidden py-32 md:py-48 lg:py-[200px]">
      {}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-between gap-1 px-4 opacity-[0.05]" aria-hidden="true">
        {Array.from({
        length: 60
      }).map((_, i) => {
        const heights = [20, 45, 70, 30, 85, 55, 40, 75, 25, 60, 90, 35, 50, 65, 80, 15, 95, 42];
        const h = heights[i % heights.length];
        return <div data-index={i} key={i} className="bg-foreground flex-1" style={{
          height: `${h}%`
        }} />;
      })}
      </div>

      {}
      <div className="pointer-events-none absolute top-1/2 left-0 hidden -translate-y-1/2 lg:block" aria-hidden="true">
        <h2 className="font-default font-bold uppercase whitespace-nowrap select-none" style={{
        transform: "rotate(-90deg) translateX(-50%)",
        transformOrigin: "left center",
        fontSize: "clamp(6rem, 12vw, 11rem)",
        letterSpacing: "-0.04em",
        color: "transparent",
        WebkitTextStroke: "1px var(--foreground)",
        lineHeight: 1
      }}>
          Formexa Impacto
        </h2>
      </div>

      <div className="relative mx-auto max-w-7xl px-6 lg:pl-32 xl:pl-40">
        {}
        <div className="mb-16 lg:hidden">
          <h2 className="font-default text-5xl font-bold uppercase tracking-tight md:text-6xl">
            Formexa Impacto
          </h2>
          <div className="mt-6 h-[3px] w-[60px] bg-primary" />
        </div>

        <div ref={ref} className="grid grid-cols-1 gap-10 md:grid-cols-3 md:gap-8">
          {stats.map((stat, i) => <div data-index={i} key={i} className={`bg-card border-t border-border p-8 md:p-10 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"} ${i === 1 ? "md:mt-20" : ""}`} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              <div className="font-default font-bold leading-none text-foreground" style={{
            fontSize: "clamp(4.5rem, 9vw, 9rem)",
            letterSpacing: "-0.04em"
          }}>
                <CountUp end={stat.value} suffix={stat.suffix} isVisible={isVisible} />
              </div>

              <div className="mt-6 h-[3px] w-[60px] bg-primary" />

              <div className="font-mono mt-6 text-xs font-medium uppercase tracking-widest text-primary md:text-sm">
                {stat.label}
              </div>

              
            </div>)}
        </div>
      </div>
    </section>;
}